import { render, staticRenderFns } from "./franchisee-detail.vue?vue&type=template&id=70a57896&scoped=true"
import script from "./franchisee-detail.vue?vue&type=script&lang=js"
export * from "./franchisee-detail.vue?vue&type=script&lang=js"
import style0 from "./franchisee-detail.vue?vue&type=style&index=0&id=70a57896&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a57896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70a57896')) {
      api.createRecord('70a57896', component.options)
    } else {
      api.reload('70a57896', component.options)
    }
    module.hot.accept("./franchisee-detail.vue?vue&type=template&id=70a57896&scoped=true", function () {
      api.rerender('70a57896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/operation-manage/franchisee-detail.vue"
export default component.exports